import { useParams } from "wouter";
import Calendar from "../../components/calendar/Calendar";
import { Navigation } from "../../components/navigation/Navigation";
import "./ProviderProfile.css"
import { useEffect, useState } from "react";
import axios from "axios";
import { api } from "../../settings/env";
import Map from "../../components/Map/Map";

export function ProviderProfile() {
  const [profile, setProfile] = useState("");
  const [profileOverview, setProfileOverview] = useState("");
  const [fullname, setFullname] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [location, setLocation] = useState(false);
  const [services, setServices] = useState([]);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [pagoMovil, setPagoMovil] = useState(false);
  const [efectivo, setEfectivo] = useState(false);
  const [vpay, setVpay] = useState(false);

  // Tap
  const [tap, setTap] = useState("info"); // info, services, comments

  // Create a new calendar
  const [monthsSelected, setMonthsSelected] = useState(1);
  const [times, setTimes] = useState(false);


  const params = useParams();

  const getServices = (id) => {
    axios.get(`${api}/services/${id}`)
      .then(resp => {
        console.log(resp.data.data)
        setServices(resp.data.data);
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    console.log("Params", params.id);

    getServices(params.id);

    axios.get(`${api}/register/professional-info/${params.id}`)
      .then(response => {
        console.log("Professional info", response.data.data);
        setProfile(response.data.data.profilePicture);
        setFullname(response.data.data.fullName);
        setDescription(response.data.data.description);
        setCategory(response.data.data.type);
        setLocation(response.data.data.location);
        setTimes(response.data.data.times);
        console.log(response.data.data.times);
      })
      .catch(error => console.error(error));


  }, [])

  const openImage = () => {
    setProfileOverview(true);
  }


  const closeImage = () => {
    setProfileOverview(false);
  }

  return (
    <div>
      <Navigation />

      <div style={{ height: "80px" }}></div>

      <div className="container">

        <div className="box-user">


          <div
            className="banner-profile"
            style={{
              backgroundImage: `url(${"https://t4.ftcdn.net/jpg/02/60/04/09/360_F_260040900_oO6YW1sHTnKxby4GcjCvtypUCWjnQRg5.jpg"})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",

              height: "400px",
              marginTop: "12px",
              borderRadius: "26px"
            }}
          >

          </div>

          <div className="user-image">
            <img
              onClick={() => openImage(profile)} src={profile}
              alt=""
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>

        {
          profileOverview &&
          <div className="profile-overview">
            <div className="top-options" onClick={closeImage}>
              X
            </div>
            <img src={profile} alt="" />
          </div>
        }

        <div className="pay-methods">
          <div className="pay">
            <img
              src="/assets/icons/vitaly-white.svg"
              alt=""
              height={"100%"}
              width={"100%"}
            />
            VPAY
          </div>

          <div className="pay">Pago Movil</div>
          <div className="pay">Efectivo</div>
        </div>

        <div className="favorites">
          <img src="" alt="" />
        </div>

        <div className="row">
          <div className="col-md-7">
            <div className="info-profile">
              <span>{category}</span>
              <h1>{fullname}</h1>

              <div className="box-info">
                <img src="" alt="" />
                <p>Anzuetegui</p>
              </div>

              <div className="box-info">
                <img src="" alt="" />
                <p>Precio desde 20$</p>
              </div>
            </div>

            <div className="tabs-profile">
              <div
                onClick={() => setTap("info")}
                className={tap == "info" ? "tab active" : "tab"}
              >
                Informacion
              </div>

              <div
                onClick={() => setTap("services")}
                className={tap == "services" ? "tab active" : "tab"}
              >
                Servicios
              </div>
              <div
                onClick={() => setTap("comments")}
                className={tap == "comments" ? "tab active" : "tab"}>
                Opiniones
              </div>
            </div>

            <div className="content my-4">

              {
                tap == "info" &&
                <div>

                  <div className="counts-box">
                    <div className="count-item">
                      Pacientes
                      <div className="count-content">
                        <img src="/assets/icons/user.png" width={"32px"} alt="" />
                        <span>300+</span>
                      </div>
                    </div>

                    <div className="count-item">
                      Experiencia
                      <div className="count-content">
                        <img src="/assets/icons/badge-check.png" width={"32px"} alt="" />
                        <span>4 yr+</span>
                      </div>
                    </div>

                    <div className="count-item">
                      Review
                      <div className="count-content">
                        <img src="/assets/icons/heart.png" width={"32px"} alt="" />
                        <span>100+</span>
                      </div>
                    </div>
                  </div>

                  <button className="btn btn-primary count-btn">
                    <img width={"40px"} src="/assets/icons/link.png" alt="" />
                    Título, posgrados y certificados
                  </button>

                </div>
              }

              {
                tap == "services" &&
                <div>

                  <div className="card-service">
                    <img width={"160px"} src="https://www.modernheartandvascular.com/wp-content/uploads/2022/10/ELECTROCARDIOGRAMA.png" alt="" />
                    <div className="content-service">
                      <p>Clinica Metropilitana</p>
                      <h5>
                        <b>Electrocardiograma</b>
                      </h5>

                      <button className="btn btn-primary">
                        Agendar cita
                      </button>
                    </div>

                    <div className="price">
                      <b>$20</b>
                    </div>
                  </div>

                </div>
              }

              {
                tap == "comments" &&
                <div>
                  Comments
                </div>
              }
            </div>


          </div>

          <div className="col-md-5">
            <Calendar
              professional_id={params.id} times={times}
              services={services}
            />
            <br /><br />

            <div width={"40px"}>

              {
                location.lat && <Map location={location} readonly={true} style={{ width: "450px", height: "400px" }} />
              }
            </div>
          </div>
        </div>


        <div style={{ height: "300px" }}></div>


      </div>

    </div>
  );
}